import React from 'react';
import { InputField, withFieldProps } from '@adjust/dashboard-components';
import { validate, isRequired, isEmail, ValidationFunctions } from '@adjust/dashboard-core/lib/validations';
import { Field } from 'formik';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState, updateEmail } from '@redux/ducks/userPermissions/userPermissions';

const emailValidation: ValidationFunctions[] = [
  [isRequired, () => t('field.email.error')],
  [isEmail, () => t('field.email.error')],
];

const ChangeUserEmailComponent = ({ isVisible, onChange, value }) =>
  isVisible ? (
    <Field name="email" validate={validate(emailValidation)}>
      {withFieldProps(<InputField label={t('field.email')} value={value} onChange={onChange} />)}
    </Field>
  ) : null;

const mapStateToProps = state => {
  const { user } = getUserPermissionsState(state);
  return { isVisible: !user?.id, value: user.email };
};

const mapStateToDispatch = {
  onChange: updateEmail,
};

export const ChangeUserEmail = connectWithStore(mapStateToProps, mapStateToDispatch)(ChangeUserEmailComponent);
